import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { DevourPlayApi, LootshopTransactionHistoryResponse, TimeFilter, Token } from "@devour/client";
import getConfig from "@/utils/getConfig";

interface UseGetTransactionHistoryLootShopParams {
    timeFilter?: TimeFilter;
    enabled?: boolean;
}

export const useGetTransactionHistoryLootShop = (
    fullToken: Token | undefined,
    params: UseGetTransactionHistoryLootShopParams = {},
): UseQueryResult<LootshopTransactionHistoryResponse, Error> => {
    const { timeFilter = TimeFilter.all, enabled = true } = params;

    return useQuery({
        queryKey: ["transaction-history-loot-shop-v1", fullToken?.token, timeFilter],
        queryFn: async (): Promise<LootshopTransactionHistoryResponse> => {
            return await new DevourPlayApi(getConfig(fullToken as any)).getDevourplayTransactionHistoryLootshop({
                timeFilter,
            });
        },
        enabled: enabled && !!fullToken?.token,
        staleTime: 30 * 1000,
        refetchOnWindowFocus: false,
    });
};
